import { format } from '../../i18n';
import { formatDate } from '../../lib/format';

/**
 * «Принесіть до 24 жовтня» — до коли родина має дати документ (047, expected_at у чеклісті кабінету).
 * Тексти тут, а не в словниках i18n, бо словники кабінету спільні для кількох батчів; перенести — ключ `case.dueBy`.
 */
const DUE_BY: Record<string, string> = {
  uk: 'Потрібно до {date}',
  en: 'Needed by {date}',
  pl: 'Potrzebne do {date}',
  ro: 'Necesar până la {date}',
  ru: 'Нужно до {date}',
};

export function dueByText(expected: string | null | undefined, locale: string): string | null {
  if (!expected) return null;
  const date = formatDate(`${expected.slice(0, 10)}T12:00:00`, locale, false);
  if (!date) return null;
  return format(DUE_BY[locale] ?? DUE_BY.uk!, { date });
}
